import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { SortableCards } from 'console/shared/components/features/sortable-cards';
import { ThermometerCard } from './thermometer-card';
import { ThermometerProvider } from './thermometer-card/provider';
export const Thermometers = memo(function Thermometers(props) {
    const { config, panel_key } = props;
    const component = useCallback((thermometer_config) => (_jsx(ThermometerProvider, { thermometer_config: thermometer_config, children: _jsx(ThermometerCard, {}) }, thermometer_config.id)), []);
    return (_jsx(SortableCards, { panel_key: panel_key, list: config, component: component, min_width: 160, min_height: 80 }));
});
